import {
  IAMAccountRawPassword,
  iamAccountRawPassword
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountPasswordUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountPasswordUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountPasswordUpdateRequestDTORaw) {
    JsonSchemaValidator.validate(
      IAMAccountPasswordUpdateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["currentPassword", "newPassword"],
      properties: {
        currentPassword: iamAccountRawPassword,
        newPassword: iamAccountRawPassword
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountPasswordUpdateRequestDTORaw {
  currentPassword: IAMAccountRawPassword;
  newPassword: IAMAccountRawPassword;
}
